/*
 * Etiqueta "% OFF" para precios rebajados por WSH Wholesale Pricing.
 *
 * La app calcula el precio en el navegador (tacha el precio de venta y muestra
 * el precio mayorista), por lo que Liquid no conoce ese descuento. Este script
 * lee los precios ya renderizados en cada tarjeta y pinta/actualiza la
 * etiqueta .badge-discount con el porcentaje real.
 */
(function () {
  'use strict';

  var OWN_ATTR = 'data-wsh-discount';

  function parseMoney(text) {
    // CLP: "$29.990" -> 29990. Quita todo lo que no sea dígito.
    var digits = String(text || '').replace(/[^\d]/g, '');
    return digits ? parseInt(digits, 10) : NaN;
  }

  function readPrices(card) {
    var container = card.querySelector('.price__container') || card.querySelector('.price');
    if (!container) return null;

    var struck = container.querySelector('s, del, strike');
    if (!struck) return null;
    var compare = parseMoney(struck.textContent);

    // Precio actual: texto del contenedor sin el precio tachado ni textos ocultos.
    var clone = container.cloneNode(true);
    clone.querySelectorAll('s, del, strike, .visually-hidden, .unit-price, .hidden').forEach(function (n) {
      n.remove();
    });
    var current = parseMoney(clone.textContent);

    if (!(compare > 0) || !(current > 0) || current >= compare) return null;
    return { compare: compare, current: current };
  }

  function ensureBadgeContainers(card) {
    var host = card.querySelector('[data-card-badges]') || card.querySelector('.card-product-badges');
    if (!host) return;
    if (host.querySelector('.badge-group--right')) return;

    host.insertAdjacentHTML(
      'beforeend',
      '<div class="badge-groups badge-groups--desktop"><div class="badge-group badge-group--right"></div></div>' +
        '<div class="badge-groups badge-groups--mobile"><div class="badge-group--anchor-top">' +
        '<div class="badge-group badge-group--right"></div></div></div>'
    );
  }

  function syncCard(card) {
    var prices = readPrices(card);

    if (!prices) {
      // Sin precio tachado: quita solo las etiquetas que creó este script.
      card.querySelectorAll('[' + OWN_ATTR + ']').forEach(function (n) {
        n.remove();
      });
      return;
    }

    var pct = Math.round(((prices.compare - prices.current) * 100) / prices.compare);
    if (pct <= 0) return;
    var label = pct + '% OFF';

    ensureBadgeContainers(card);

    card.querySelectorAll('.badge-group--right').forEach(function (group) {
      var badge = group.querySelector('.badge-discount');
      if (!badge) {
        badge = document.createElement('span');
        badge.className = 'badge-discount';
        badge.setAttribute(OWN_ATTR, '');
        group.insertBefore(badge, group.firstChild);
      }
      if (badge.textContent !== label) badge.textContent = label;
      badge.style.display = 'block';
    });
  }

  function syncAll() {
    document.querySelectorAll('.card-wrapper').forEach(syncCard);
  }

  var timer = null;
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(syncAll, 150);
  }

  function init() {
    syncAll();
    new MutationObserver(schedule).observe(document.body, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
